import { connect } from 'react-redux';
import WorklistSubMenu from '../components/submenu';
import { getWorklistDefinitions } from './worklist-actions';

const mapDispatchToProps = {
  getWorklistDefinitions,
};

const mapStateToProps = state => ({
  definitions: state.worklist.definitions,
  isDefinitionsLoading: state.worklist.isDefinitionsLoading,
});

export default connect(mapStateToProps, mapDispatchToProps)(WorklistSubMenu);
